import React, { createContext, ReactElement } from 'react';

import { BoxProps, TextProps } from '@rover/kibble/core';
import { BoxWebOnlyProps } from '@rover/kibble/core/Box/Box.common';

export type AccordionItemColorOption = 'primary' | 'primary_inverse';
export type AccordionDefaultOpenOption = 'first' | 'all' | 'none';

export type SchemaProps = Pick<BoxWebOnlyProps, 'itemScope' | 'itemType' | 'itemProp'>;

export type AccordionContextValue = {
  itemColorVariant: AccordionItemColorOption;
  headingSize: TextProps['size'];
  itemSchemaProps?: SchemaProps;
  bodySchemaProps?: SchemaProps;
};

export type AccordionItemProps = Pick<BoxProps, 'testID'> & {
  itemHeading: React.ReactNode;
  itemBody: React.ReactNode;
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

export type AccordionItemElement = ReactElement<AccordionItemProps>;

export type AccordionProps = Omit<BoxProps, 'webAs'> & {
  accordionItems?: AccordionItemProps[];
  itemColorVariant?: AccordionItemColorOption;
  headingSize?: AccordionContextValue['headingSize'];
  itemSchemaProps?: SchemaProps;
  bodySchemaProps?: SchemaProps;
  defaultOpen?: AccordionDefaultOpenOption;
};

export const AccordionContext = createContext<AccordionContextValue>({
  itemColorVariant: 'primary',
  headingSize: '300',
});

export const getIsOpenByIndex = (
  index: number,
  defaultOpen: AccordionDefaultOpenOption
): boolean => {
  return defaultOpen === 'all' || (defaultOpen === 'first' && index === 0);
};
